import { useShowSnackbar } from "hooks/useShowSnackbar";
import { useEffect } from "react";
import { SNACKBAR_NOTIFICATION_KEYS } from "constants/notifications";
import { RecoverPasswordForm } from "components/UI/organisms";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import { INTERNAL_PATHS } from "routes/paths";
import "./index.scss";

export const RecoverPassword = () => {
  const { removeNotification } = useShowSnackbar();
  useEffect(() => {
    return () => {
      // clear notification error on component unmount
      removeNotification(SNACKBAR_NOTIFICATION_KEYS.USED_RESET_TOKEN);
    };
  }, [removeNotification]);

  return (
    <>
      <ReactHelmetWithProvider>
        <title>Reset Password - GCX</title>
        <link
          href={window.location.origin + INTERNAL_PATHS.RESET_PASSWORD}
          rel="canonical"
        />
      </ReactHelmetWithProvider>
      <div className="recover-password-container">
        <aside />
        <main className="reset-password-content">
          <h1 className="page-title">Reset Password</h1>
          <p className="page-description">
            Enter the email address associated with your account, and we'll
            email you a link to reset your password.
          </p>

          <RecoverPasswordForm />
        </main>
      </div>
    </>
  );
};
